module.exports = __webpack_public_path__ + "img/02.a196e71c.png";